import axios from "axios";
import { storeAction } from "../storeActions.constant";
import { storeGetters } from "../storeGetters.constant";
import { storeMutation } from "../storeMutations.constant";
import { getBasicHeaders, getHeadersWithFormData } from "../../common/utils/utils";
import { wrapAction } from "../../common/utils/actionLifecycle";
import { chapterWaiverConstants } from "../../components/ChapterWaiver/ChapterWaiver.constants";
import uniqBy from "lodash/uniqBy";
import { getAxiosCancelTokenSource } from '@/app.utils';

const chapterWaiverState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    waiverTypes: [],
    listOfWaivers: [],
    visibleProspect: null,
    waiverQuestions: [],
    companyTypes: [],
    waiverDetails: null,
    prpRole: {},
    isPRPAdmin: false,
    isPRPMember: false,
    isActive: false,
    nextWaiverListPageNumber: 0,
    noMoreWaiverListToFetch: false,
    disableWaiverListInfiniteScroll: false,
    waiverSentBackToChapter: false,
    regionalCommentSaved: false,
    sentBackErrorOccurred: false,
    completeWaiverDetails: [],
    prpMemberList: [],
    regionalCommentsErrorOccurred: false,
    memberVoteStatus: [],
    voteStatusError: false,
    finalizeEmailRecipients: null,
    waiverAttachmentSaved: false,
    finalizeError: false,
    searchResults: [],
    chunkedSearchResults: [],
    corporationTypes: [],
    titleTypes: [],
    printWaiverDetails: [],
};

const chapterWaiverMutations = {
    [storeMutation.setWaiverTypes]: (state, data) => {
        state.waiverTypes = data;
    },
    [storeMutation.setPrintWaiverDetails]: (state, data) => {
        state.printWaiverDetails = data;
    },
    [storeMutation.setListOfWaivers]: (state, data) => {
        if (state.listOfWaivers && state.listOfWaivers.length) {
            let newItemPushed = false;
            data.forEach((item) => {
                const alreadyExist = state.listOfWaivers.some(it => it.id === item.id);
                if (!alreadyExist) {
                    state.listOfWaivers.push(item);
                    newItemPushed = true;
                }
            });
            if (newItemPushed) {
                state.listOfWaivers = uniqBy(state.listOfWaivers, "id");
                state.nextWaiverListPageNumber += 1;
            }
        } else {
            state.listOfWaivers = uniqBy(data, "id");
            state.nextWaiverListPageNumber += 1;
        }
    },
    [storeMutation.resetChapterWaiverList]: (state) => {
        state.listOfWaivers = [];
        state.visibleProspect = null;
        state.nextWaiverListPageNumber = 0;
        state.noMoreWaiverListToFetch = false;
    },
    [storeMutation.setVisibleProspect]: (state, data) => {
        state.visibleProspect = data;
    },
    [storeMutation.setCompanyTypes]: (state, data) => {
        data.forEach((x) => {
            state.companyTypes.push(x.type);
        });
    },
    [storeMutation.setWaiverDetails]: (state, data) => {
        if (!data.isSearchView) {
            if (state.waiverQuestions && data && data.waiverAnswerList) {
                state.waiverQuestions.forEach((question) => {
                    if (!data.waiverAnswerList.some(x => x.questionId === question.id)) {
                        data.waiverAnswerList.push({
                            questionId: question.id,
                            answer: "",
                        });
                    }
                });
            }
        }
        if (data && data.attachments && data.attachments.length > 0) {
            const files = [];
            data.attachments.forEach((file) => {
                if (typeof file === "string") {
                    files.push({
                        name: file.substr(file.lastIndexOf("/") + 1, file.length),
                        url: file,
                    });
                }
            });
            data.attachments = files;
        }
        state.waiverDetails = data;
        if (state.waiverDetails && state.waiverDetails.dollarVolume) {
            state.waiverDetails.dollarVolume = state.waiverDetails.dollarVolume.toLocaleString();
        }
        if (state.waiverDetails && state.waiverDetails.totalCompensation) {
            state.waiverDetails.totalCompensation = state.waiverDetails.totalCompensation.toLocaleString();
        }
        if (state.waiverDetails && state.waiverDetails.enterpriseValue) {
            state.waiverDetails.enterpriseValue = state.waiverDetails.enterpriseValue.toLocaleString();
        }
    },
    [storeMutation.setWaiverQuestions]: (state, data) => {
        if (data) {
            state.waiverQuestions = data;
            state.waiverQuestions[1].question = {
                part1: state.waiverQuestions[1].question.substring(0, 17),
                part2: state.waiverQuestions[1].question.substring(18, 69),
                part3: state.waiverQuestions[1].question.substring(70),
            };
        }
    },
    [storeMutation.setPRPRole]: (state, data) => {
       state.prpRole = data;
       state.isPRPAdmin = data.isAdmin;
       state.isPRPMember = data.isMember;
       state.isActive = data.isActive;
    },
    [storeMutation.setChapterWaiverListInfiniteScroll]: (state, val) => {
        state.disableWaiverListInfiniteScroll = val;
    },
    [storeMutation.setSentBackToChapter]: (state, data) => {
        state.waiverSentBackToChapter = data;
    },
    [storeMutation.setSentBackError]: (state, data) => {
        state.sentBackErrorOccurred = data !== 200;
    },
    [storeMutation.setStatusAfterSentBackToChapter]: (state, leadId) => {
        if (leadId && state.listOfWaivers && state.listOfWaivers.some(item => item.id === leadId)) {
            state.listOfWaivers.find(item => item.id === leadId).waiverStatus = "Chapter_needs_to_submit";
            state.listOfWaivers.find(item => item.id === leadId).waiverFlowStatus = "ReSubmit";
            state.listOfWaivers.find(item => item.id === leadId).waiverRequestedDate = Date.now();
        } else if (state.waiverDetails) {
            state.waiverDetails.waiverStatus = "Chapter_needs_to_submit";
            state.waiverDetails.waiverFlowStatus = "ReSubmit";
            state.waiverDetails.waiverRequestedDate = Date.now();
        }
        if (state.listOfWaivers && state.waiverDetails && state.listOfWaivers.some(item => item.id === state.waiverDetails.id)) {
            state.listOfWaivers.find(item => item.id === state.waiverDetails.id).waiverStatus = state.waiverDetails.waiverStatus;
            state.listOfWaivers.find(item => item.id === state.waiverDetails.id).waiverFlowStatus = state.waiverDetails.waiverFlowStatus;
            state.listOfWaivers.find(item => item.id === state.waiverDetails.id).waiverRequestedDate = state.waiverDetails.waiverRequestedDate;
        }
    },
    [storeMutation.setCompleteWaiverDetails]: (state, data) => {
        if (state.completeWaiverDetails.length === 0 || state.completeWaiverDetails.some(item => item.id !== data.id)) {
            state.completeWaiverDetails.push(data);
        }
    },
    [storeMutation.setWaiverStatusLocally]: (state, req) => {
        if (!state.waiverDetails) {
            state.listOfWaivers.find(item => item.id === req.leadId).waiverStatus = req.waiverStatus;
            state.listOfWaivers.find(item => item.id === req.leadId).waiverFlowStatus = req.waiverFlowStatus;
            if (req.waiverFlowStatus === chapterWaiverConstants.RESEND_TO_REGION) {
                state.listOfWaivers.find(item => item.id === req.leadId).waiverSentForCommentsDate = Date.now();
            } else if (req.waiverFlowStatus === chapterWaiverConstants.RESEND_TO_PRP) {
                state.listOfWaivers.find(item => item.id === req.leadId).waiverPostedToPrpdate = Date.now();
            }
        } else {
            state.waiverDetails.waiverStatus = req.waiverStatus;
            state.waiverDetails.waiverFlowStatus = req.waiverFlowStatus;
            if (req.waiverFlowStatus === chapterWaiverConstants.RESEND_TO_REGION) {
                state.waiverDetails.waiverSentForCommentsDate = Date.now();
            } else if (req.waiverFlowStatus === chapterWaiverConstants.RESEND_TO_PRP) {
                state.waiverDetails.waiverPostedToPrpdate = Date.now();
            }
        }
        if (state.listOfWaivers && state.waiverDetails && state.listOfWaivers.some(item => item.id === state.waiverDetails.id)) {
            state.listOfWaivers.find(item => item.id === state.waiverDetails.id).waiverStatus = state.waiverDetails.waiverStatus;
            state.listOfWaivers.find(item => item.id === state.waiverDetails.id).waiverFlowStatus = state.waiverDetails.waiverFlowStatus;
            if (req.waiverFlowStatus === chapterWaiverConstants.RESEND_TO_REGION) {
                state.listOfWaivers.find(item => item.id === state.waiverDetails.id).waiverSentForCommentsDate = state.waiverDetails.waiverSentForCommentsDate;
            } else if (req.waiverFlowStatus === chapterWaiverConstants.RESEND_TO_PRP) {
                state.listOfWaivers.find(item => item.id === state.waiverDetails.id).waiverPostedToPrpdate = state.waiverDetails.waiverPostedToPrpdate;
            }
        }
    },
    [storeMutation.setPrpMemberList]: (state, data) => {
        state.prpMemberList = data;
    },
    [storeMutation.setRegionalCommentsError]: (state, data) => {
        state.regionalCommentsErrorOccurred = data !== 200;
    },
    [storeMutation.setRegionalCommentsSaved]: (state, data) => {
        state.regionalCommentSaved = data;
    },
    [storeMutation.removeLeadFromWaiverList]: (state, id) => {
        state.listOfWaivers = state.listOfWaivers.filter(item => item.id !== id);
    },
    [storeMutation.setStatusAfterVote]: (state, params) => {
        if (params.votestatus === chapterWaiverConstants.APPROVED) {
            state.listOfWaivers.find(item => item.id === params.leadid).waiverFlowStatus = "Approved_by_Member";
        } else if (params.votestatus === chapterWaiverConstants.DENIED) {
            state.listOfWaivers.find(item => item.id === params.leadid).waiverFlowStatus = "Denied_by_Member";
        }
    },
    [storeMutation.setVoteStatusError]: (state, data) => {
        state.voteStatusError = data !== 200;
    },
    [storeMutation.setFinalizeEmailRecipients]: (state, data) => {
        state.finalizeEmailRecipients = data;
    },
    [storeMutation.setWaiverAttachmentSaved]: (state, data) => {
        state.waiverAttachmentSaved = data;
    },
    [storeMutation.setFinalizeStatusError]: (state, data) => {
        state.finalizeError = data !== 200;
    },
    [storeMutation.setSearchResults]: (state, data) => {
        state.chunkedSearchResults = data && data.length && data.length > 5 ? data.slice(5, data.length) : null;
        state.searchResults = data ? data.slice(0, 5) : null;
    },
    [storeMutation.pushSearchResults]: (state) => {
        state.searchResults = state.searchResults.concat(state.chunkedSearchResults);
        state.chunkedSearchResults = null;
    },
    [storeMutation.removeSearchResults]: (state) => {
        state.waiverDetails = null;
    },
    [storeMutation.setCorporationTypes]: (state, data) => {
        state.corporationTypes = data;
    },
    [storeMutation.setTitleTypes]: (state, data) => {
        state.titleTypes = data;
    },
};

const chapterWaiverActions = {
    [storeAction.getWaiverTypes]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/get-types`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setWaiverTypes, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getListOfWaivers]: wrapAction(storeAction.getListOfWaivers, ({ state, commit }, req) => {
        const pageNumber = state.nextWaiverListPageNumber;
        if (!state.noMoreWaiverListToFetch) {
            commit(storeMutation.setChapterWaiverListInfiniteScroll, true);
            return axios({
                url:
                    req && req.communityId
                        ? `${state.baseURL}waiver/api/waivers/get-requests/${
                        req.viewType
                        }?pageNumber=${pageNumber}&communityId=${req.communityId}&leadId=${req.leadId}`
                        : `${state.baseURL}waiver/api/waivers/get-requests/${
                        req.viewType
                        }?pageNumber=${pageNumber}&sortType=${req.sortType}&filterBy=${req.filterType}&leadId=${req.leadId}`,
                headers: getBasicHeaders(),
                method: "GET",
            })
                .then((response) => {
                    if (response && response.data) {
                        if (!response.data.length || response.data.length < 20 || response.data.id != null) {
                            state.noMoreWaiverListToFetch = true;
                        }
                        commit(storeMutation.setListOfWaivers, response.data);
                    }
                    commit(storeMutation.setChapterWaiverListInfiniteScroll, false);
                })
                .catch((err) => {
                    commit(storeMutation.setListOfWaivers, []);
                    commit(storeMutation.setChapterWaiverListInfiniteScroll, false);
                    console.log(err);
                    throw err;
                });
        }
    }),
    [storeAction.getWaiverDetails]: wrapAction(storeAction.getWaiverDetails, ({ state, commit }, req) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/get-details/${req.leadId}/${req.viewType}?communityId=${req.communityId}`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                response.data.isSearchView = req && req.isSearchView;
                commit(storeMutation.setWaiverDetails, response.data);
                commit(storeMutation.setCompleteWaiverDetails, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getWaiverQuestions]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/get-questions`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setWaiverQuestions, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getPRPRole]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/get-prp-role`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setPRPRole, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getCompanyTypes]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/get-company-types`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setCompanyTypes, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.uploadWaiverFiles]: wrapAction(storeAction.uploadWaiverFiles, ({ state, commit }, postData) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/upload-attachments/${postData.leadId}`,
            headers: getHeadersWithFormData(),
            data: postData.formData,
            method: "POST",
        })
            .then((response) => {
                commit(storeMutation.setWaiverAttachmentSaved, response.status === 200);
                return response.data;
            })
            .catch((err) => {
                console.error(err);
                throw err;
            });
    }),
    [storeAction.deleteWaiverFiles]: ({ state }, params) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/delete-attachment`,
            headers: getBasicHeaders(),
            data: params,
            method: "DELETE",
        })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },

    [storeAction.sendWaiverBackToChapterOfficer]: wrapAction(
        storeAction.sendWaiverBackToChapterOfficer,
        ({ state, commit }, req) => {
            return axios({
                url: `${state.baseURL}waiver/api/waivers/send-back-to-chapter`,
                headers: getBasicHeaders(),
                data: req,
                method: "POST",
            })
                .then((response) => {
                    commit(storeMutation.setSentBackToChapter, response.data);
                    return response;
                })
                .catch((err) => {
                    commit(storeMutation.setSentBackError, err.response.status);
                    console.log(err);
                });
        },
    ),

    [storeAction.submitWaiverRequest]: wrapAction(storeAction.submitWaiverRequest, ({ state }, requestBody) => {
        requestBody.attachments = null;
        return axios({
            url: `${state.baseURL}waiver/api/waivers/submit-request/${requestBody.viewType}`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: "POST",
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveWaiverRequest]: wrapAction(storeAction.saveWaiverRequest, ({ state }, req) => {
        req.attachments = null;
        return axios({
            url: `${state.baseURL}waiver/api/waivers/submit-request/${req.viewType}?isdraft=${req.isDraft}`,
            headers: getBasicHeaders(),
            data: req,
            method: "POST",
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.sendToRegion]: wrapAction(storeAction.sendToRegion, ({ state, commit }, req) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/send-to-region/${req.leadId}`,
            headers: getBasicHeaders(),
            method: "POST",
        })
            .then((response) => {
                commit(storeMutation.setWaiverStatusLocally, req);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.sendToPRP]: wrapAction(storeAction.sendToPRP, ({ state, commit }, postBody) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/send-to-prp`,
            headers: getBasicHeaders(),
            data: postBody,
            method: "POST",
        })
            .then((response) => {
                commit(storeMutation.setWaiverStatusLocally, postBody);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getPRPMemberList]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/get-reviewmembers`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setPrpMemberList, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.saveRegionalOfficerComments]: wrapAction(
        storeAction.saveRegionalOfficerComments,
        ({ state, commit }, req) => {
            return axios({
                url: `${state.baseURL}waiver/api/waivers/add-comment/REGIONALOFFICER?communityId=${req.communityId}`,
                headers: getBasicHeaders(),
                data: req,
                method: "POST",
            })
                .then((response) => {
                    commit(storeMutation.setRegionalCommentsSaved, response.data);
                    return response;
                })
                .catch((err) => {
                    commit(storeMutation.setRegionalCommentsError, err.response.status);
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.submitVote]: wrapAction(storeAction.submitVote, ({ state, commit }, req) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/submit-vote`,
            headers: getBasicHeaders(),
            data: req,
            method: "POST",
        })
            .then((response) => {
                commit(storeMutation.setStatusAfterVote, req);
                return response;
            })
            .catch((err) => {
                commit(storeMutation.setVoteStatusError, err.response.status);
                console.log(err);
            });
    }),
    [storeAction.savePRPMemberDenyReason]: wrapAction(
        storeAction.saveRegionalOfficerComments,
        ({ state, commit }, req) => {
            return axios({
                url: `${state.baseURL}waiver/api/waivers/add-comment/PRPMEMBER`,
                headers: getBasicHeaders(),
                data: req,
                method: "POST",
            })
                .then((response) => {
                    return response;
                })
                .catch((err) => {
                    commit(storeMutation.setVoteStatusError, err.response.status);
                    console.log(err);
                });
        },
    ),
    [storeAction.getFinalizeEmailRecipients]: ({ state, commit }, chapterId) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/get-finalizemail-recipients/${chapterId}`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setFinalizeEmailRecipients, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.finalizeWaiverRequest]: wrapAction(
        storeAction.finalizeWaiverRequest,
        ({ state, commit }, postBody) => {
            return axios({
                url: `${state.baseURL}waiver/api/waivers/finalize-request`,
                headers: getBasicHeaders(),
                data: postBody.finalize,
                method: "POST",
            })
                .then((response) => {
                    commit(storeMutation.setWaiverStatusLocally, postBody.leadDetails);
                    return response;
                })
                .catch((err) => {
                    commit(storeMutation.setFinalizeStatusError, err.response.status);
                    console.log(err);
                });
        },
    ),
    [storeAction.searchWaiverRequests]: wrapAction(storeAction.searchWaiverRequests, ({ state, commit }, req) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/search/${req.viewType}?communityId=${
                req.communityId
                }&searchToken=${req.searchToken}`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setSearchResults, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    }),
    [storeAction.searchUsersForFinalizeMail]: wrapAction(storeAction.searchUsersForFinalizeMail, ({ state, commit }, searchToken) => {
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.searchUsersForFinalizeMail,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, {
            root: true,
        });
        return axios({
            url: `${state.baseURL}profiles/api/search-people/${searchToken}`,
            headers: getBasicHeaders(),
            method: "GET",
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.searchUsersForFinalizeMail, { root: true });
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    }),
    [storeAction.getCorporationTypes]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/get-corporation-types`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setCorporationTypes, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getTitleTypes]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}waiver/api/waivers/get-title-types`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setTitleTypes, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
};

const chapterWaiverGetters = {
    [storeGetters.waiverTypes]: state => state.waiverTypes,
    [storeGetters.listOfWaivers]: state => state.listOfWaivers,
    [storeGetters.visibleProspect]: state => state.visibleProspect,
    [storeGetters.waiverQuestions]: state => state.waiverQuestions,
    [storeGetters.prpRole]: state => state.prpRole,
    [storeGetters.companyTypes]: state => state.companyTypes,
    [storeGetters.waiverDetails]: state => state.waiverDetails,
    [storeGetters.completeWaiverDetails]: state => state.completeWaiverDetails,
    [storeGetters.disableWaiverListInfiniteScroll]: state => state.disableWaiverListInfiniteScroll,
    [storeGetters.waiverSentBackToChapter]: state => state.waiverSentBackToChapter,
    [storeGetters.regionalCommentSaved]: state => state.regionalCommentSaved,
    [storeGetters.sentBackErrorOccurred]: state => state.sentBackErrorOccurred,
    [storeGetters.regionalCommentsErrorOccurred]: state => state.regionalCommentsErrorOccurred,
    [storeGetters.prpMemberList]: state => state.prpMemberList,
    [storeGetters.memberVoteStatus]: state => state.memberVoteStatus,
    [storeGetters.voteStatusError]: state => state.voteStatusError,
    [storeGetters.finalizeEmailRecipients]: state => state.finalizeEmailRecipients,
    [storeGetters.waiverAttachmentSaved]: state => state.waiverAttachmentSaved,
    [storeGetters.finalizeError]: state => state.finalizeError,
    [storeGetters.searchResults]: state => state.searchResults,
    [storeGetters.chunkedSearchResults]: state => state.chunkedSearchResults,
    [storeGetters.corporationTypes]: state => state.corporationTypes,
    [storeGetters.titleTypes]: state => state.titleTypes,
    [storeGetters.printWaiverDetails]: state => state.printWaiverDetails,
    [storeGetters.isPRPAdmin]: state => state.isPRPAdmin,
    [storeGetters.isPRPMember]: state => state.isPRPMember,
    [storeGetters.isActive]: state => state.isActive,
};

export default {
    namespaced: true,
    state: {
        initialState: chapterWaiverState,
        ...chapterWaiverState,
    },
    mutations: { ...chapterWaiverMutations },
    actions: { ...chapterWaiverActions },
    getters: { ...chapterWaiverGetters },
};
